<template>
  <div class="flex cursor-pointer flex-row items-center button-select">
    <div
      v-for="(item, index) of buttondata"
      :key="index"
      class="flex items-center justify-center ml-2"
      @click="changeState(index)"
    >
      <feather :class="{ active: item.active }" :type="item.icon.type" :size="item.icon.size" />
    </div>
  </div>
</template>

<script>
export default {
	name: 'ButtonSelect',
	props: {
		data: {
			type: Array,
			default: () => [],
		},
	},
	data() {
		return {
			buttondata: this.data || [],
		};
	},
	computed: {},
	methods: {
		changeState(index) {
			if (this.buttondata[index]) {
				this.buttondata.forEach((item, i) => {
					if (i === index) {
						// eslint-disable-next-line no-param-reassign
						item.active = true;
					} else {
						// eslint-disable-next-line no-param-reassign
						item.active = false;
					}
				});
			}
		},
	},
};
</script>

<style lang="scss" scoped>
.button-select .active {
	transition: 0.3s ease-in-out;
	color: #09af5f;
}
</style>
